<template>
  <div>
    <!-- 选项：用于证书制作，选择课程内容时。  -->
    <div>
      <el-checkbox :indeterminate="isIndeterminate"
                   v-model="checkAll"
                   @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0"></div>
      <div style="display: inline-block; margin-right: 20px"
           v-for="item in data_list"
           :key="item.section_id">
        <el-checkbox :label="item"
                     v-model="checked_data_list"
                     @change="handleCheckedCourseChange">{{ item.section_name }}</el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selece-area',
  data() {
    return {
      checkAll: false,
      course_string: '',
      checked_data_list: [],
      checked: null,
      isIndeterminate: false,
      data_list: this.data,
    }
  },
  props: {
    data: Array,
  },
  watch: {
    data: {
      handler(newValue) {
        this.data_list = newValue
      },
    },
  },
  methods: {
    test() {
      console.log(this.data_list)
    },
    handleCheckAllChange(val) {
      // console.log(val);
      //   console.log("------------");
      //   console.log(this.data_list);
      //   console.log("------------");
      new Promise((resolve, reject) => {
        this.checked_data_list = val ? this.data_list : []
        this.isIndeterminate = false
        resolve()
      }).then(() => {
        this.$emit('checkALl', this.checked_data_list)
        console.log(this.checked_data_list)
      })
    },
    handleCheckedCourseChange(value) {
      //   console.log(this.checked_data_list);
      this.$emit('checkCourse', this.checked_data_list)
      //   //
      let checkedCount = this.checked_data_list.length
      this.checkAll = checkedCount === this.data_list.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.data_list.length
    },
  },
}
</script>

<style>
</style>